
import React, { useState, useEffect } from 'react';
import '../css/dataTablePopUp.css';


const PieChartPopupComponent = ({ onClose, onRemoveTable, nodeName,
  selectedNodeId, onValueSubmit, selectedCurrentDatabasesCombined, selectedCurrentTablesCombined,
  selectedColumnsCombined, selectedIdsOnly,
  selectedCombinedColumnsValue, selectedIdsCombinedColumnsValue,
  selectedLabelTypeValue }) => {

  const labelType = [
    { label: 'option1', value: 'Name Only' },
    { label: 'option2', value: 'Name and Value' },
    { label: 'option3', value: 'Name and Percentage' },
  ];

  const [name, setName] = useState(nodeName);
  const [selectedCombinedColumns, setSelectedCombinedColumns] = useState(selectedCombinedColumnsValue &&
    selectedCombinedColumnsValue.length > 0 ? selectedCombinedColumnsValue : selectedColumnsCombined[0]);

  const [selectedIdsCombinedColumns, setSelectedIdsCombinedColumns] = useState(selectedIdsCombinedColumnsValue &&
    selectedIdsCombinedColumnsValue.length > 0 ? selectedIdsCombinedColumnsValue : selectedIdsOnly[0]);


  const [selectedLabelType, setSelectedLabelType] = useState(selectedLabelTypeValue &&
    selectedLabelTypeValue.length > 0 ? selectedLabelTypeValue : labelType[0].value);


  // const [columnLabelIndexValue, setColumnLabelIndexValue] = useState(selectedCombinedColumns.indexOf(selectedColumnsCombined[0]));

  // const [formSubmitted, setFormSubmitted] = useState(false);
  const handleLinkClick = () => {
    // Perform any actions when the link is clicked
    // ...
  };
  const handleRemoveTable = () => {
    // Call the onRemoveTable callback function
    if (onRemoveTable) {
      onRemoveTable();
    }
    // Close the popup
    onClose();
  };


  useEffect(() => {
    // setShowAdditionalInputs(showAdditionalinputlength > 0 ? [{}] : []);

    setName(nodeName);
    setSelectedCombinedColumns(selectedCombinedColumns);
    setSelectedIdsCombinedColumns(selectedIdsCombinedColumns);
    setSelectedLabelType(selectedLabelType);
    // setSelectedColumns(selectedColumns);
    //  setShowAdditionalInputs(showAdditionalinputlength);
  }, [nodeName, selectedCombinedColumns, selectedIdsCombinedColumns, selectedLabelType]
  );

  // Function to update the dynamic value
  const handleNameChange = (event) => {

    setName(event.target.value);
  };


  const handleSubmit = (event) => {
    event.preventDefault();
    // setFormSubmitted(true);
    // alert(formSubmitted);
    // alert(JSON.stringify(columnLabelIndexValue) + "columnLabelIndexValue");
    onValueSubmit(selectedNodeId, name,
      selectedCombinedColumns, selectedIdsCombinedColumns,
      selectedLabelType, selectedColumnsCombined);

  };



  const handleColumnChange = (event) => {
    const selectedColumnName = event.target.value;

    setSelectedCombinedColumns(selectedColumnName);

    // const columnLabelIndex = selectedColumnsCombined.indexOf(selectedColumnName);
    // setColumnLabelIndexValue(columnLabelIndex);
    // setFormSubmitted(true);
  };

  const handleIdsColumnChange = (event) => {
    const selectedIdsColumnName = event.target.value;
    setSelectedIdsCombinedColumns(selectedIdsColumnName);
  };

  const handleLabelTypeChange = (event) => {
    const selectedLabelType = event.target.value;
    setSelectedLabelType(selectedLabelType);
  };

  const renderColumnOptions = () => {
    if (selectedColumnsCombined) {
      return selectedColumnsCombined.map((column) => (
        <option key={column} value={column}>
          {column}
        </option>
      ));
    }
    return null;
  };
  const renderIdsColumnOptions = () => {
    if (selectedIdsOnly) {
      return selectedIdsOnly.map((column) => (
        <option key={column} value={column}>
          {column}
        </option>
      ));
    }
    return null;
  };



  return (
    <div className="overlay">

      <div className="popup-datatable">
        <div className="popup-header">
          <h4 class='modal-title'>Tool Options</h4>
          <button className="close-button" onClick={onClose}>

            <span>&times;</span>
          </button>
        </div>
        <div className="datatable-content">
          <div className="modal-body">
            <div className="form-group">
              <label htmlFor="textbox">Name</label>
              <input type="text" value={name}
                className="form-control"
                onChange={handleNameChange}
                id="textbox" />

            </div>

            <div className="form-group">
              <label htmlFor="dropdown">Label</label>
              <select
                id="dropdown"
                className="form-control"

                value={selectedCombinedColumns}
                onChange={handleColumnChange}
              >
                {renderColumnOptions()}
              </select>

            </div>

            <div className="form-group">
              <label htmlFor="dropdown">Value</label>
              <select
                id="dropdown"
                className="form-control"

                value={selectedIdsCombinedColumns}
                onChange={handleIdsColumnChange}
              >
                {renderIdsColumnOptions()}
              </select>

            </div>
            <div className="form-group">
              <label htmlFor="dropdown">Label Type</label>
              <select
                id="dropdown"
                className="form-control"
                value={selectedLabelType}
                onChange={handleLabelTypeChange}
              >
                {labelType.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.value}
                  </option>
                ))}
              </select>
            </div>
            <div className="form-group toolHelpLink">
              <a href="https://example.com" target="_blank" onClick={handleLinkClick}>
                How does this tool work?
              </a>
            </div>
          </div>
          <div className="modal-footer">
            <button type='button' onClick={handleRemoveTable} class='btn btn-danger remove'>Remove Tool</button>
            <button type='button' className='btn btn-primary ok' onClick={handleSubmit}>OK</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PieChartPopupComponent;
